<template>
  <section>   
    <div v-for="child in getChildGoalProgress" :key="child.child">
      <div class="d-flex aling-items-center">
        <p class="mr-2">{{child.child_name}} Goals</p>
        <question-popup
          :popoverKey="`goals-skill-${child.child}`"
          :title="childPopups.goal.title"
          :description="childPopups.goal.information"
          class="text-main2"
        />
      </div>
    <bar-chart
        :series="calculeSerie(child)"
        :categories="calculeCategories(child)"
        title=""
        yTitle="Challenge"
        xTitle="Percentage"
        :height="450"
        :horizontal="true"
        :customOptions="customOptions"
      />
    </div>
  </section>
</template>
<script>
import {  mapGetters, mapActions } from "vuex";
import barChart from "@/components/apexCharts/BarChart.vue";
import QuestionPopup from "@/components/general/QuestionPopup.vue";

export default { 
  data(){
    return{
      customOptions:{
        tooltip:{
          y:{
            formatter: function(val){
              return Math.abs(val)+"%"
            }
          }
        },
        yaxis:{
          min:0,
          max:100,
          title:{
            text: ""
          },
        },
        xaxis:{
          labels:{
            formatter: function(val){
              return Math.abs(Math.round(val)) + "%"
            }
          }
        }
      }
    }
  },
  components:{
    barChart,
    QuestionPopup
},
  methods:{
    ...mapActions("progress",["FetchChildrenStarProgress", "childPopups"]),
    calculeSerie(data){
      let serie = []
      data.challenges_progress.map(element=>{
        serie.push({
          x:element.challenge,
          y:Math.round((element.percentage_approved * 100).toFixed(2))
        })
       })
    return [
        {
          name:"Challenges",
          type: 'column',
          data: serie
        },
    ]
    },
    calculeCategories(data){
        let categories=[]
        data.challenges_progress.map(element=>{
            categories.push(element.challenge)
        })
        return categories
    }
  },
  computed:{
    ...mapGetters("progress",["getChildGoalProgress", "childPopups"]),
    ...mapGetters("user",["getUserId"])
  }
}
</script>